import Cookies from 'js-cookie';

export default {

	init() {
		// Check for cookie and fallback to users browser preference
		if (!Cookies.get('theme')) {
			const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
			Cookies.set('theme', theme);
			document.querySelector('html').classList.add(theme);
		}

		const themeSwitcher = document.querySelector('.js-theme-switcher');
		if (themeSwitcher) {
			themeSwitcher.addEventListener('click', (event) => {
				event.preventDefault();
				if (document.querySelector('html').classList.contains('dark')) {
					Cookies.set('theme', 'light', { expires: 90 });
					document.querySelector('html').classList.add('light');
					document.querySelector('html').classList.remove('dark');
				} else {
					Cookies.set('theme', 'dark', { expires: 90 });
					document.querySelector('html').classList.add('dark');
					document.querySelector('html').classList.remove('light');
				}
			});
		}
	},

};
